import { Fragment } from 'react';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

interface BreadcrumbProps {
  items?: Array<{
    label: string;
    href?: string;
  }>;
}

export const Breadcrumb = ({ items = [] }: BreadcrumbProps) => {
  const { t } = useTranslation();

  return (
    <nav className="mc-crumb" aria-label="Breadcrumb">
      <Link to="/">{t('app.nav.dashboard')}</Link>
      {items.map((item, index) => (
        <Fragment key={index}>
          <span aria-hidden="true">›</span>
          {item.href ? (
            <Link to={item.href}>{item.label}</Link>
          ) : (
            <span aria-current="page">{item.label}</span>
          )}
        </Fragment>
      ))}
    </nav>
  );
};
